import UserManagementList from './UserManagementList';

export default UserManagementList;
